var map = {
	"./API DOCUMENTATION 1.svg": 250,
	"./API DOCUMENTATION 2.svg": 1501,
	"./Dashboard 1.svg": 2728,
	"./Dashboard 2.svg": 4902,
	"./MTN AXIS 1.svg": 1996,
	"./MTN AXIS 2.svg": 6622,
	"./Manage commission 1.svg": 375,
	"./Manage commission 2.svg": 5997,
	"./Manage voucher 1.svg": 2199,
	"./Manage voucher 2.svg": 343,
	"./Manage wallet 1.svg": 7849,
	"./Manage wallet 2.svg": 6938,
	"./Plan orders 1.svg": 8082,
	"./Plan orders 2.svg": 3027,
	"./Reports 1.svg": 8090,
	"./Reports 2.svg": 6160,
	"./Settings 1.svg": 9196,
	"./Settings 2.svg": 1791,
	"./Support1.svg": 6990,
	"./Support2.svg": 3702,
	"./Transactions 1.svg": 8945,
	"./Transactions 2.svg": 9105,
	"./airtime.svg": 1419,
	"./cable.svg": 7792,
	"./data.svg": 2909,
	"./elec.svg": 8824,
	"./exam.svg": 2352,
	"./kanban-fill.svg": 3356,
	"./treshold.svg": 7330,
	"./user 1.svg": 6389,
	"./user 2.svg": 9868,
	"./wife.svg": 3306
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2967;